import { Json } from '../types/types';

export const mergeCollections = (a: Json, b: Json = {}) => {
  let id,
    output: any = {};

  for (id in b) {
    output[id] = mergeItems(a[id], b[id]);
  }

  for (id in a) {
    if (output[id]) {
      continue;
    }

    output[id] = mergeItems(a[id], b[id]);
  }

  return output;
};

export const mergeItems = (a = {}, b = {}) => {
  return { ...a, ...b };
};
